let startTime = 0;
let enabled = false;

const timer = {
  setEnabled: (state) => {
    enabled = state;
  },
  start: () => {
    startTime = Date.now();
  },
  getInterval: () => (enabled ? (Date.now() - startTime) / 1000 : 0),
};

export default timer;
